import "core-js/modules/es.array.reverse.js";
var _class, _YDYRCatalogFunctionJob;
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action, runInAction, makeObservable } from "mobx";
import filterOutUndefined from "../../../Core/filterOutUndefined";
import isDefined from "../../../Core/isDefined";
import loadJson from "../../../Core/loadJson";
import loadWithXhr from "../../../Core/loadWithXhr";
import CatalogFunctionJobMixin from "../../../ModelMixins/CatalogFunctionJobMixin";
import TableMixin from "../../../ModelMixins/TableMixin";
import YDYRCatalogFunctionJobTraits from "../../../Traits/TraitsClasses/YDYRCatalogFunctionJobTraits";
import CommonStrata from "../../Definition/CommonStrata";
import CreateModel from "../../Definition/CreateModel";
import CsvCatalogItem from "../CatalogItems/CsvCatalogItem";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
import { ALGORITHMS, DATASETS } from "./YDYRCatalogFunction";
let YDYRCatalogFunctionJob = (_class = (_YDYRCatalogFunctionJob = class YDYRCatalogFunctionJob extends CatalogFunctionJobMixin(CreateModel(YDYRCatalogFunctionJobTraits)) {
  constructor() {
    super(...arguments);
    makeObservable(this);
  }
  get typeName() {
    return "YourDataYourRegions Job";
  }
  get type() {
    return YDYRCatalogFunctionJob.type;
  }
  async _invoke() {
    var _DATASETS$find, _data$ids, _data$values, _DATASETS$find2, _DATASETS$find3, _tableCatalogItem$act;
    if (!isDefined(this.parameters)) {
      throw "Parameters have not been set";
    }
    if (!isDefined(this.parameters["apiUrl"])) {
      throw "The apiUrl parameter must be defined.";
    }
    if (!isDefined(this.parameters["Input Layer"])) {
      throw "The input layer must be defined";
    }
    const tableCatalogItem = this.terria.workbench.items.filter(TableMixin.isMixedInto).filter(item => item.uniqueId === this.parameters["Input Layer"])[0];
    if (!isDefined(tableCatalogItem)) {
      throw "Layer ".concat(this.parameters["Input Layer"], " is not a valid layer in the workbench");
    }
    if (!isDefined(this.parameters["Region Column"]) || !isDefined(this.parameters["Data Column"]) || !isDefined(this.parameters["Output Geography"])) {
      throw "The region column, data column and output geography must be defined";
    }
    const regionColumnName = this.parameters["Region Column"];
    const dataColumnName = this.parameters["Data Column"];
    const outputGeographyName = this.parameters["Output Geography"];
    const regionColumn = tableCatalogItem === null || tableCatalogItem === void 0 ? void 0 : tableCatalogItem.findColumnByName(regionColumnName);
    const dataColumn = tableCatalogItem === null || tableCatalogItem === void 0 ? void 0 : tableCatalogItem.findColumnByName(dataColumnName);
    this.setTrait(CommonStrata.user, "name", "YDYR ".concat(tableCatalogItem.name, ": ").concat(dataColumnName));
    const jobDetails = this.addObject(CommonStrata.user, "shortReportSections", "Job Details");
    jobDetails === null || jobDetails === void 0 || jobDetails.setTrait(CommonStrata.user, "content", "".concat(dataColumnName, ": \"").concat((_DATASETS$find = DATASETS.find(d => {
      var _regionColumn$regionT;
      return d.geographyName === (regionColumn === null || regionColumn === void 0 || (_regionColumn$regionT = regionColumn.regionType) === null || _regionColumn$regionT === void 0 ? void 0 : _regionColumn$regionT.regionType);
    })) === null || _DATASETS$find === void 0 ? void 0 : _DATASETS$find.title, "\" to \"").concat(outputGeographyName, "\""));
    const data = {
      ids: regionColumn === null || regionColumn === void 0 ? void 0 : regionColumn.values,
      values: dataColumn === null || dataColumn === void 0 ? void 0 : dataColumn.valuesAsNumbers.values
    };
    if (!((_data$ids = data.ids) !== null && _data$ids !== void 0 && _data$ids.length) || !((_data$values = data.values) !== null && _data$values !== void 0 && _data$values.length)) {
      throw "The column selected has no valid data values";
    }

    // Remove rows with null values
    const invalidRows = filterOutUndefined(data.values.map((val, idx) => val === null ? idx : undefined));
    data.ids = data.ids.filter((_id, idx) => !invalidRows.includes(idx));
    data.values = data.values.filter((_value, idx) => !invalidRows.includes(idx));
    const params = {
      data,
      data_column: dataColumnName,
      geom_column: regionColumnName,
      side_data: (_DATASETS$find2 = DATASETS.find(d => d.title === outputGeographyName)) === null || _DATASETS$find2 === void 0 ? void 0 : _DATASETS$find2.sideData,
      dst_geom: (_DATASETS$find3 = DATASETS.find(d => d.title === outputGeographyName)) === null || _DATASETS$find3 === void 0 ? void 0 : _DATASETS$find3.geographyName,
      src_geom: tableCatalogItem === null || tableCatalogItem === void 0 || (_tableCatalogItem$act = tableCatalogItem.activeTableStyle.regionColumn) === null || _tableCatalogItem$act === void 0 || (_tableCatalogItem$act = _tableCatalogItem$act.regionType) === null || _tableCatalogItem$act === void 0 ? void 0 : _tableCatalogItem$act.regionType,
      averaged_counts: false,
      algorithms: ALGORITHMS.filter(alg => this.parameters[alg[0]]).map(alg => alg[0])
    };
    const jobId = await loadWithXhr({
      url: proxyCatalogItemUrl(this, "".concat(this.parameters["apiUrl"], "disaggregate.json")),
      method: "POST",
      data: JSON.stringify(params),
      headers: {
        "Content-Type": "application/json"
      },
      responseType: "json"
    });
    if (typeof jobId !== "string") {
      // TODO: improve error messaging

      // This is from previous YDYR web-app

      //   switch(createJobReponse.status) {
      //     case 202:
      //       createJobReponse.response
      //       break
      //     case 500:
      //       break
      //     default:
      //       break
      //   }

      //   if(r.status === 202) {
      //     // then the request was accepted
      //     r.json().then(j => poller(j));
      // } else if(r.status === 500) {
      //     // server error
      //     r.json().then(e => error({
      //         title: (e && e.title) || 'Server Error',
      //         detail: 'Job failed to submit' +
      //             ((e && e.detail) ? (': ' + e.detail) : '')}));
      // } else {
      //     const subber = s => {
      //         if(s.includes('is not valid under any of the given schemas')) {
      //             return 'invalid JSON data';
      //         }
      //         return s.length < 100 ? s : (s.substring(0, 100) + '...');
      //     }

      //     r.json()
      //       .then(e => error({
      //         title: (e && e.title) || 'Server Error',
      //         detail: 'Unexpected status (' + r.status.toString() + ') ' +
      //             'when submitting job' +
      //                 ((e && e.detail) ? (': ' + subber(e.detail)) : '')}))
      //       .catch(e => error({
      //         title: (e && e.title) || 'Error parsing JSON response',
      //         detail: `Received ${r.status} response code and failed to parse response as JSON`
      //       }));
      // }
      throw "The YDYR server didn't provide a valid job id.";
    }
    this.setTrait(CommonStrata.user, "jobId", jobId);
    return false;
  }
  async pollForResults() {
    if (!isDefined(this.jobId)) {
      console.log("NO JOB ID");
      return true;
    }
    if (!isDefined(this.parameters["apiUrl"])) {
      console.log("apiUrl parameter is not defined");
      return true;
    }
    const status = await loadJson(proxyCatalogItemUrl(this, "".concat(this.parameters["apiUrl"], "status/").concat(this.jobId)), {
      "Cache-Control": "no-cache"
    });
    if (typeof status !== "string") {
      runInAction(() => this.setTrait(CommonStrata.user, "logs", [...this.logs, JSON.stringify(status)]));
      this.setTrait(CommonStrata.user, "resultId", status.key);
      return true;
    } else {
      runInAction(() => this.setTrait(CommonStrata.user, "logs", [...this.logs, status]));
      return false;
    }
  }
  async downloadResults() {
    if (!isDefined(this.resultId)) {
      return [];
    }
    if (!isDefined(this.parameters["apiUrl"])) {
      console.log("apiUrl parameter is not defined");
      return [];
    }
    const csvResult = new CsvCatalogItem("".concat(this.uniqueId, "-result"), this.terria, undefined);
    runInAction(() => {
      csvResult.setTrait(CommonStrata.user, "name", "".concat(this.name, " Results"));
      csvResult.setTrait(CommonStrata.user, "url", proxyCatalogItemUrl(this, "".concat(this.parameters["apiUrl"], "download/").concat(this.resultId, "?format=csv")));
      csvResult.setTrait(CommonStrata.user, "enableManualRegionMapping", true);
    });
    return [csvResult];
  }
}, _defineProperty(_YDYRCatalogFunctionJob, "type", "ydyr-job"), _YDYRCatalogFunctionJob), _applyDecoratedDescriptor(_class.prototype, "_invoke", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_invoke"), _class.prototype), _class);
export { YDYRCatalogFunctionJob as default };